import pathfinder from '@fiverr-private/pathfinder';
import {
    PATHS,
    MODES,
    PATHFINDER,
    formatQueryParams,
    getCategorySlug,
    getSubCategorySlug,
    getNestedSubCategorySlug,
} from '../../utils';

export const getNestedSubCategoryPath = (
    { categoryId, id, nestedSubCategoryId, mode, filter, queryParams, source },
    locale
) => {
    if (mode === MODES.PRO) {
        return PATHS.ROOT;
    }

    if (!(categoryId && id && nestedSubCategoryId)) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(categoryId, 10)) || isNaN(parseInt(id, 10)) || isNaN(parseInt(nestedSubCategoryId, 10))) {
        return PATHS.ROOT;
    }

    const categorySlug = getCategorySlug(categoryId, locale);
    const subCategorySlug = getSubCategorySlug(id, locale);
    const nestedSubCategorySlug = getNestedSubCategorySlug(nestedSubCategoryId, id, locale);

    const params = {
        category_id: categorySlug,
        id: subCategorySlug,
        nested_sub_category_id: nestedSubCategorySlug,
    };

    return pathfinder(PATHFINDER.NESTED_SUB_CATEGORY, params, formatQueryParams({ filter, queryParams, source }));
};
